// src/App.jsximport React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Navbar from './components/NavBar'; // Import the Navbar
import Home from './components/home/Home';
import VenueList from './components/venue/Venues';
import Types from './components/types/Types'
import Amenities from './components/amenity/Amenities'
import VenueSpacesList from './components/venueSpace/VenueSpaces';
import VenueSpacePrices from './components/venueSpacePrices/VenueSpacePrices';
import VenueSpaceLayouts from './components/venue_space_layouts/VenueSpaceLayouts';
import VenueSpaceFeaturesList from './components/venue_space_features/VenueSpaceFeatures';
import VenuePricesList from './components/venue_prices/VenuePrices';
import VenueFeaturesList from './components/venue_features/VenueFeatures';
import AuthForm from './components/Authform';
import Chat from './components/Chat';
import Ask from './components/Ask';
import Quote from './components/Quote';
import History from './components/History';
//import EventPackagesExplainer from './components/EventPackagesExplainer';
import Contact from './components/Contact';
import './App.css'; // Import your custom CSS if any
//import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
//import TextGenerator from './components/TextGenerator';
import EventPackagesExplainer from './components/EventPackagesExplainer';
import RFP from './components/RFP';
import './App.css'; // Import your custom CSS if any
//import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import EventPlannerExplainer from './components/EventPlannerExplainer';
import TextGenerator from './components/TextGenerator';

// Protected Route component to handle authentication
const ProtectedRoute = ({ element, allowedRoles }) => {
  const { isAuthenticated, userRole } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/signup" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

const AppContent = () => {
  return (
    <Router>
      <Navbar />
      <div className="container-full mt-4">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<EventPlannerExplainer />} />
          <Route path="/signup" element={<AuthForm />} />

          <Route path="/" element={<EventPlannerExplainer  />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/packages" element={< EventPackagesExplainer/>} />
          <Route path="/rfp" element={<RFP />} />
          <Route path="/iplanner" element={<EventPlannerExplainer />} />
          <Route path="/reserve" element={<TextGenerator />} />


          {/* Protected route accessible by both admin and event-user */}
          <Route 
            path="/chat" 
            element={
              <ProtectedRoute 
                element={<Chat />} 
                allowedRoles={['admin', 'event-user']} 
              />
            } 
          />
          <Route 
            path="/ask" 
            element={
              <ProtectedRoute 
                element={<Ask />} 
                allowedRoles={['admin', 'event-user']} 
              />
            } 
          />
          <Route 
            path="/quote" 
            element={
              <ProtectedRoute 
                element={<Quote />} 
                allowedRoles={['admin', 'event-user']} 
              />
            } 
          />
          <Route 
            path="/history" 
            element={
              <ProtectedRoute 
                element={<History />} 
                allowedRoles={['admin', 'event-user']} 
              />
            } 
          />
        </Routes>
      </div>
    </Router>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;

// const App = () => {
//   return (
//     <Router>
//       <Navbar /> {/* Use Navbar component here */}
//       <div className="container mt-4">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/signup" element={<AuthForm />} />
//           <Route path="/venue" element={<Venue />} />
//           <Route path="/types" element={<Types/>}/>
//           <Route path="/amenities" element={<Amenities/>}/>
//           <Route path="/venue_spaces" element={<VenueSpacesList/>}/>
//           <Route path="/venue_space_prices" element={<VenueSpacePrices/>}/>
//           <Route path="/venue_space_layouts" element={<VenueSpaceLayouts/>}/>
//           <Route path="/venue_space_features" element={<VenueSpaceFeaturesList/>}/>
//           <Route path="/venue_prices" element={<VenuePricesList/>}/>
//           <Route path="/venue_features" element={<VenueFeaturesList/>}/>
//           <Route path="/chat" element={<Chat />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// };


